// extracted by mini-css-extract-plugin
export var chip = "_ap-0";
export var filterDropdown = "_ap-5";
export var filterItem = "_ap-6";
export var icon = "_ap-1";
export var removeButton = "_ap-3";
export var removeIcon = "_ap-4";
export var separator = "_ap-2";